import _s from 'underscore.string';

export default {
  filters: {
    formatCurrency(val) {
      return _s.numberFormat(parseFloat(val), 2, ',', '.') + ' €';
    },
    formatPercent(val) {
      return _s.numberFormat(parseFloat(val), 2, ',', '.') + ' %';
    },
    formatDate(val) {
      return (new Date(val * 1000)).toLocaleDateString('de-DE');
    },
    formatTime(val) {
      return (new Date(val * 1000)).toLocaleDateString('de-DE', { hour: 'numeric', minute: 'numeric' });
    },
    shorten(value) {
      return value.substring(0, 7);
    },
    formatSize(val) {
      if (typeof val === 'undefined')
        return 0;

      let size = typeof val === 'string' ? parseInt(val) : val;
      if (size === 0)
        return 0;

      let i = Math.floor(Math.log(size) / Math.log(1024));
      return (size / Math.pow(1024, i)).toFixed(2) * 1 + ' ' + ['B', 'KB', 'MB', 'GB', 'TB'][i];
    }
  }
}
